<template>
  <div id="app">
    <div class="window-title-bar" @mousedown="handleTitleBarMouseDown">
      <div class="title">国惠云打印渲染引擎 V{{ versionData.self }}</div>
      <div class="window-controls">
        <button class="control-button minimize" @mousedown.stop @click="minimize">
          <svg viewBox="0 0 10 1">
            <rect width="10" height="1" />
          </svg>
        </button>
        <button class="control-button maximize" @mousedown.stop @click="toggleMaximize">
          <svg v-if="!isMaximized" viewBox="0 0 10 10">
            <rect width="9" height="9" x="0.5" y="0.5" rx="1" stroke-width="1" />
          </svg>
          <svg v-else viewBox="0 0 10 10">
            <path d="M2,2v6h6V2H2z M8,7H3V3h5V7z M1,1v8h3v1H0V1H1z M9,1v8h-1V1H9z" />
          </svg>
        </button>
        <button class="control-button close" @mousedown.stop @click="close">
          <svg viewBox="0 0 10 10">
            <path d="M0,0 L10,10 M10,0 L0,10" stroke="currentColor" stroke-width="1.5" />
          </svg>
        </button>
      </div>
    </div>
    <router-view />
    <!-- 固定在右下角的日志图标 -->
    <div class="log-icon-container" @click="toggleDrawer">
      <el-badge :is-dot="hasNewMessages" class="badge-item">
        <el-button circle class="log-icon" type="primary" icon="el-icon-document" />
      </el-badge>
    </div>

    <!-- 日志抽屉 -->
    <el-drawer title="运行日志" :visible.sync="drawer" :with-header="false" direction="rtl" size="40%">
      <div class="drawer-header">
        <h3>运行日志</h3>
        <div>
          <el-button size="mini" @click="toggleAutoScroll" :type="autoScroll ? 'primary' : 'text'">
            自动滚动{{ autoScroll ? '✔' : '' }}
          </el-button>
          <el-button size="mini" @click="clearMessages" type="text">
            清空
          </el-button>
        </div>
      </div>

      <div class="message-container" ref="messageContainer" @scroll="handleScroll">
        <div v-for="(msg, index) in messages" :key="index" class="message-item">
          <span class="timestamp">{{ msg.timestamp }}</span>
          <span class="title">[{{ msg.title }}]</span>
          <span class="message">{{ msg.message }}</span>
        </div>

        <div v-if="messages.length === 0" class="empty-message">
          暂无日志消息
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { fa } from 'element-plus/es/locales.mjs';

export default {
  name: 'App',
  data() {
    return {
      versionData: {
        self: '',
        cef_version: '',
        product: ''
      },
      isMaximized: false,
      isDragging: false,
      isMessageWindow: false,
      drawer: false,
      messages: [],
      hasNewMessages: false,
      unreadCount: 0,
      autoScroll: true, // 默认开启自动滚动
      isScrollingUp: false
    };
  },
  watch: {
    messages() {
      this.$nextTick(() => {
        if (this.autoScroll && !this.isScrollingUp) {
          this.scrollToBottom();
        }
      });
    }
  },
  created() {
    window.js_api_cross_call(
      JSON.stringify({ "func": "show", "data": { "show": true, "x": 0, "y": 0, "w": 1932, "h": 1200 } }),
      function (data) {
        console.log(data);
      });
      this.fetchVersionInfo();
    window.cef_call_MessageWindow = this.cef_call_MessageWindow;
  },
  methods: {
    fetchVersionInfo() {
      this.loading = true;

      try {
        window.js_api_cross_call(
          JSON.stringify({ "func": "get_version", "data": {} }),
          (response) => {
            const data = JSON.parse(response);
            if (data.code === 200) {
              this.versionData = data.data;
              this.lastUpdateTime = new Date().toLocaleString();
              this.$message.success('版本信息获取成功');
            } else {
              this.$message.error(data.msg || '获取版本信息失败');
            }
            this.loading = false;
          }
        );
      } catch (error) {
        console.error('调用版本接口失败:', error);
        this.$message.error('调用版本接口失败');
        this.loading = false;
      }
    },
    toggleDrawer() {
      this.drawer = !this.drawer;
      if (this.drawer) {
        this.hasNewMessages = false;
        this.$nextTick(() => {
          this.scrollToBottom();
        });
      }
    },

    scrollToBottom() {
      const container = this.$refs.messageContainer;
      if (container) {
        container.scrollTop = container.scrollHeight;
      }
    },

    handleScroll() {
      const container = this.$refs.messageContainer;
      if (container) {
        // 判断用户是否手动向上滚动
        const threshold = 50; // 阈值
        this.isScrollingUp = container.scrollTop + container.clientHeight < container.scrollHeight - threshold;
      }
    },

    toggleAutoScroll() {
      this.autoScroll = !this.autoScroll;
      if (this.autoScroll) {
        this.scrollToBottom();
      }
    },

    cef_call_MessageWindow(show, title, message) {
      // 获取当前时间
      const now = new Date();
      const timestamp = `${now.getFullYear()}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getDate().toString().padStart(2, '0')} ${now.getHours().toString().padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')}`;

      // 添加新消息
      this.messages.push({
        timestamp,
        title,
        message
      });

      // 如果有新消息且抽屉未打开，显示红点
      if (!this.drawer) {
        this.hasNewMessages = true;
      }

      // 控制抽屉显示
      // if (show) {
      //   this.drawer = true;
      //   this.hasNewMessages = false;
      // }

      // 限制消息数量
      if (this.messages.length > 200) {
        this.messages.shift();
      }
    },

    clearMessages() {
      this.messages = [];
    },
    callWindowAPI(func, data = {}, callback = null) {
      const request = {
        func,
        tag: this.tag,
        data
      };
      console.log('Calling window API:', request);
      if (typeof window.js_api_cross_call === 'function') {
        window.js_api_cross_call(JSON.stringify(request), (response) => {
          const res = typeof response === 'string' ? JSON.parse(response) : response;
          if (callback) callback(res);
          this.$emit('api-response', res);
        });
      } else {
        console.warn('js_api_cross_call is not available');
        // For demo purposes, simulate a response
        const mockResponse = {
          func,
          tag: this.tag,
          code: 200,
          msg: 'success',
          data: {}
        };
        if (func === 'desktop_size') {
          mockResponse.data = { w: 1920, h: 1080 };
        }
        if (callback) callback(mockResponse);
        this.$emit('api-response', mockResponse);
      }
    },

    minimize() {
      this.callWindowAPI('minimize');
      this.$emit('minimize');
    },

    maximize() {
      this.callWindowAPI('maximize', {}, (res) => {
        if (res.code === 200) {
          this.isMaximized = true;
          this.$emit('maximize');
        }
      });
    },

    restore() {
      this.callWindowAPI('restore', {}, (res) => {
        if (res.code === 200) {
          this.isMaximized = false;
          this.$emit('restore');
        }
      });
    },

    toggleMaximize() {
      if (this.isMaximized) {
        this.restore();
      } else {
        this.maximize();
      }
    },

    close() {
      console.log('Closing window');
      this.callWindowAPI('close', { tray: false });
    },

    handleTitleBarMouseDown(e) {
      // Only start drag on left mouse button
      if (e.button !== 0) return;

      this.callWindowAPI('move_begin');
      this.isDragging = true;

      const handleMouseUp = () => {
        if (this.isDragging) {
          this.callWindowAPI('move_end');
          this.isDragging = false;
        }
        document.removeEventListener('mouseup', handleMouseUp);
      };

      document.addEventListener('mouseup', handleMouseUp);
    },

    getDesktopSize() {
      return new Promise((resolve) => {
        this.callWindowAPI('desktop_size', {}, (res) => {
          resolve(res.data);
        });
      });
    }
  },
}
</script>

<style>
body {
  margin: 0;
  padding: 0;
  user-select: none;          /* 标准 */
  -webkit-user-select: none;  /* Safari/旧 Chrome */
  -moz-user-select: none;     /* 旧 Firefox */
}



.window-messages {
  position: fixed;
  bottom: 10px;
  left: 10px;
  width: 250px;
  height: 80px;
  background-color: rgba(255, 255, 255, 0.8);
  color: rgb(9, 9, 9);
  padding: 20px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  border-radius: 5px;
  z-index: 1000;
}

.window-title-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 30px;
  background-color: #f0f0f0;
  border-bottom: 1px solid #ddd;
  padding: 0 10px;
  user-select: none;
  -webkit-app-region: drag;
}

.title {
  font-size: 12px;
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  -webkit-app-region: drag;
}

.window-controls {
  display: flex;
  -webkit-app-region: no-drag;
}

.control-button {
  width: 30px;
  height: 30px;
  border: none;
  background: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  margin: 0;
  outline: none;
}

.control-button svg {
  width: 10px;
  height: 10px;
  fill: currentColor;
  stroke: currentColor;
}

.control-button:hover {
  background-color: #e5e5e5;
}

.close:hover {
  background-color: #e81123;
  color: white;
}

.minimize svg {
  fill: currentColor;
}

.maximize svg {
  stroke: currentColor;
  fill: none;
}

/* 日志图标容器 - 固定在右下角 */
.log-icon-container {
  position: fixed;
  right: 60px;
  bottom: 60px;
  z-index: 9999;
  cursor: pointer;
}

/* 徽标样式 */
.badge-item>>>.el-badge__content.is-fixed.is-dot {
  right: 10px;
  top: 10px;
}

/* 日志图标按钮 */
.log-icon {
  width: 50px;
  height: 50px;
  font-size: 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.2);
}

/* 抽屉头部样式 */
.drawer-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid #ebeef5;
}

.drawer-header h3 {
  margin: 0;
  color: #333;
}

/* 消息容器 - 添加滚动条样式 */
.message-container {
  padding: 10px 20px;
  height: calc(100vh - 60px);
  overflow-y: auto;
  scroll-behavior: smooth;
  /* 平滑滚动 */
}

/* 自定义滚动条样式 */
.message-container::-webkit-scrollbar {
  width: 6px;
}

.message-container::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.message-container::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.message-container::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* 单条消息样式 */
.message-item {
  margin-bottom: 12px;
  font-size: 13px;
  line-height: 1.6;
  word-break: break-word;
}

.timestamp {
  color: #909399;
  margin-right: 8px;
}

.title {
  color: #409EFF;
  font-weight: bold;
  margin-right: 5px;
}

.message {
  color: #606266;
}

/* 空消息提示 */
.empty-message {
  color: #909399;
  text-align: center;
  padding: 20px;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue